import { render, staticRenderFns } from "./SeedingPositionBindModal.vue?vue&type=template&id=3cddf0aa"
import script from "./SeedingPositionBindModal.vue?vue&type=script&lang=js"
export * from "./SeedingPositionBindModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports